import { i18next } from './i18n';

export default i18next;
